var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('transition',{attrs:{"name":"fade-slow","mode":"out-in"}},[(!_vm.authorized)?_c('router-view'):(!_vm.ready)?_c('BLayoutEmpty',{attrs:{"loading":""}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }